import { useQuery } from '@tanstack/react-query'
import getFarmQuantificationUnits from '../../services/ruutsApi/v2/farms/quantificationUnits/getFarmQuantificationUnits'
import type {
  FarmQuantificationUnit,
  FarmQuantificationUnitsParams,
  UnassignedPaddock,
} from '../../types/apiModels'
import { queryKeys } from './queryKeys'

// Module scope so the key stays value-stable across renders.
const DEFAULT_PARAMS: FarmQuantificationUnitsParams = {
  sort: 'baselineYear:asc,createdAt:asc',
  limit: 100,
  offset: 0,
}

export type UseFarmQuantificationUnitsResult = {
  quantificationUnits: FarmQuantificationUnit[] | null
  unassignedPaddocks: UnassignedPaddock[] | null
  hasPlan: boolean
  isLoading: boolean
  refetch: () => Promise<unknown>
}

export const useFarmQuantificationUnits = ({
  farmId,
}: {
  farmId: string | null | undefined
}): UseFarmQuantificationUnitsResult => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: queryKeys.quantificationUnits(farmId ?? undefined, DEFAULT_PARAMS),
    queryFn: ({ signal }) =>
      getFarmQuantificationUnits({ farmId: farmId as string, params: DEFAULT_PARAMS, signal }),
    enabled: !!farmId,
  })

  return {
    quantificationUnits: data?.items ?? null,
    unassignedPaddocks: data?.meta?.unassignedPaddocks ?? null,
    hasPlan: data?.meta?.hasPlan ?? false,
    isLoading,
    refetch,
  }
}
